import type { LayerSection } from 'features/mapping/mapping.types';

import { LAYER_SECTION_ICONS } from './layerSectionIcons';
import type { LayerSectionIconProps } from './LayerSectionIcon.types';

type LayerSectionIconComponentProps = LayerSectionIconProps & {
  section: LayerSection;
};

export const LayerSectionIcon = (
  props: LayerSectionIconComponentProps,
): JSX.Element => {
  const { section, ...iconProps } = props;
  const Icon = LAYER_SECTION_ICONS[section];

  return <Icon {...iconProps} />;
};
